import React from 'react'
import { DesignProvider } from 'contexts/DesignContext'
import Page from './Page'

const Index = (props) => {
  return (
    <React.Fragment>
      <DesignProvider>
        <Page {...props} />
      </DesignProvider>
    </React.Fragment>
  )
}

export default Index
